import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Mail, MessageCircle, Phone, Clock } from "lucide-react";
import LeadForm from "../components/LeadForm";
import PageHero from "../components/PageHero";

const HERO_IMG = "https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1800&q=80";

const fadeUp = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: "easeOut" },
};

export default function ContactoPage() {
  const { t } = useTranslation();

  const channels = [
    {
      icon: Mail,
      label: "Email",
      value: t("contacto.channels.email"),
      href: `mailto:${t("contacto.channels.email")}`,
    },
    {
      icon: Phone,
      label: "Teléfono",
      value: t("contacto.channels.whatsapp"),
      href: "tel:+584121496804",
    },
    {
      icon: MessageCircle,
      label: "WhatsApp",
      value: t("contacto.channels.whatsapp"),
      href: "https://wa.me/584121496804",
      external: true,
    },
  ];

  return (
    <main>
      <PageHero
        eyebrow={t("contacto.hero.eyebrow")}
        title={t("contacto.hero.title")}
        subtitle={t("contacto.hero.subtitle")}
        image={HERO_IMG}
        imageAlt="Espacio de trabajo moderno"
      />

      <section className="section-y">
        <div className="container-page grid lg:grid-cols-5 gap-12">
          {/* Channels */}
          <div className="lg:col-span-2 space-y-4">
            <h2 className="text-xl font-semibold mb-2">{t("contacto.channels.title")}</h2>
            {channels.map((c, i) => {
              const Icon = c.icon;
              return (
                <a
                  key={i}
                  href={c.href}
                  target={c.external ? "_blank" : undefined}
                  rel={c.external ? "noreferrer" : undefined}
                  className="block p-6 rounded-2xl border border-border bg-card/40 hover:border-dc-amber-light dark:hover:border-dc-amber transition-colors group"
                >
                  <div className="flex items-center gap-4">
                    <div className="w-11 h-11 rounded-xl bg-dc-amber-light/10 dark:bg-dc-amber/15 text-dc-amber-light dark:text-dc-amber flex items-center justify-center group-hover:scale-110 transition-transform">
                      <Icon className="w-5 h-5" />
                    </div>
                    <div>
                      <div className="text-xs uppercase tracking-wider text-muted-foreground">{c.label}</div>
                      <div className="font-medium">{c.value}</div>
                    </div>
                  </div>
                </a>
              );
            })}

            <div className="p-6 rounded-2xl border border-border bg-card/40">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-xl bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
                  <Clock className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider text-muted-foreground mb-1">Horario</div>
                  <div className="text-sm leading-relaxed">Lun – Vie, 9:00 a 18:00 (GMT-4)<br/>Respondemos en menos de 24h</div>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <div className="lg:col-span-3 glass-card p-8 md:p-10">
            <LeadForm pageOrigin="contacto" />
          </div>
        </div>
      </section>
    </main>
  );
}
